// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Chart direction context. Wave B widget wrappers bridge the i18n `dir` into
 * this context (or pass `dir` straight to a chart); inside the charts package
 * the policy is applied per scale: categorical x mirrors, time x never does.
 */
import { createContext, useContext } from 'react';
export const ChartDirectionContext = createContext('ltr');
/** Resolved direction: explicit prop wins, then the nearest provider ('ltr' default). */
export function useChartDir(override) {
    const inherited = useContext(ChartDirectionContext);
    return override ?? inherited;
}
/** Convenience boolean used by geometry callers. */
export function useRtl(override) {
    return useChartDir(override) === 'rtl';
}
//# sourceMappingURL=useRtl.js.map